<template>
    <v-container
        v-resize="onResize"
        fluid
        class="overflow-y-hidden pa-0"
        ref="container"
        style="height:100%"
    >
        <v-progress-linear
            :active="loading"
            color="primary"
            height="3"
            indeterminate
            absolute
            top
        ></v-progress-linear>
        <v-text-field
            v-model="userFilter"
            backgroundColor="#eee"
            class="black--text mx-2 mt-1 mb-2"
            clearable
            dense
            filled
            hide-details="auto"
            placeholder="Project Manager / Project"
            prepend-inner-icon="mdi-magnify"
            rounded
        />
        <v-card
            flat
            :class="{
                'overflow-x-auto': $vuetify.breakpoint.smAndDown,
                '': $vuetify.breakpoint.mdAndUp,
            }"
        >
            <div>
                <v-row class="flex-nowrap ma-0">
                    <v-col
                        class="pl-2 pr-0 py-0 ma-0"
                        v-for="user of filterUsers"
                        :key="user.id"
                        cols="8"
                        xl="3"
                        lg="3"
                        md="5"
                    >
                        <ProjectUserColumn
                            :height="height"
                            :user="user"
                            :users="users"
                            :clients="clients"
                        />
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import API from '@/services/api'
import ProjectUserColumn from '@/components/Projects/ProjectUserColumn.vue'
import { mapMutations } from 'vuex'

export default {
    name: 'PurchasingAssign',
    components: {
        ProjectUserColumn,
    },
    data: () => ({
        loading: false,
        projects: [],
        users: [],
        clients: [],
        height: 0,
        userFilter: '',
        clientsMap: {},
    }),
    computed: {
        filterUsers() {
            const filter = this.userFilter.toLowerCase()
            return this.users
                .filter(user => {
                    const name = user.name?.toLowerCase() || ''

                    // get project names
                    const projectNames = (user.projects || [])
                        .map(p => p.name?.toLowerCase() || '')
                        .join(' ')

                    return (
                        name.includes(filter) || projectNames.includes(filter)
                    )
                })
                .sort((a, b) => a.name.localeCompare(b.name))
        },
    },
    async mounted() {
        try {
            this.loading = true
            this.onResize()
            // get projects
            this.projects = await API.getProjects({})
            // set clients
            const {
                data: { clients },
            } = await API.getLiteClients()
            this.clients = clients
            this.clientsMap = clients.reduce((map, c) => {
                map[c.id] = c.name
                return map
            }, {})
            // get users and assign the projects
            const {
                data: { users },
            } = await API.getUsers()
            // Group the projects by projectManager
            const projectsByPM = {}
            for (const project of this.projects) {
                const pmId = project.projectManager
                if (!projectsByPM[pmId]) {
                    projectsByPM[pmId] = []
                }
                // get client name
                project.clientName = this.getClientName(project.client)
                projectsByPM[pmId].push(project)
            }
            // Assign Projects to users
            for (const user of users) {
                user.projects = projectsByPM[user.id] || []
            }
            // exclude users without projects
            this.users = users.filter(user => user.projects.length > 0)
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    updated() {
        this.onResize()
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        onHoldLog: async function(evt) {
            window.console.log(evt)
        },
        onResize() {
            const {
                container: { clientHeight: containerHeight },
            } = this.$refs
            this.height = containerHeight + 19
        },
        getClientName(clientId) {
            return this.clientsMap[clientId] || ''
        },
    },
}
</script>

<style></style>
